import { makeStyles, createStyles } from "@material-ui/core";
import * as React from "react";

import {
    EditIcon,
    EnhancedTable,
    EnvelopeIcon,
    InterviewStatusDisplay,
    Link,
    PageActionButton,
    RelodeTheme,
    TableColumn,
    TableOptions,
    Text,
    useDeviceSize,
} from "../../..";
import * as domain from "../../../domain";
import { CandidateInterviewListProps } from "./candidateJobInterviewListProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            actionButton: {
                margin: theme.spacing(0, 0, 0, 0.5),
                padding: theme.spacing(0),
            },
        }),
    { name: "CandidateJobInterviewListDesktop" }
);

export const CandidateJobInterviewListDesktop = (
    props: CandidateInterviewListProps
) => {
    const {
        interviewList,
        handleOpenEditInterview,
        handleOpenInterviewDetails,
        handleOpenInterviewNotificationDialog,
        dataCy,
    } = props;
    const classes = useStyles({});
    const extendedId = "candidateJobInterviewList";

    const options: TableOptions = {
        title: "",
        color: "primary",
        hideCheckbox: true,
    };

    const device = useDeviceSize();

    const isLastColumnHidden =
        !handleOpenEditInterview && !handleOpenInterviewNotificationDialog;

    const columns: TableColumn[] = [
        {
            title: "date and time",
            field: "interviewStartDateTime",
            sortable: false,
            columnSize: "largest",
            render: (interview: domain.CandidateInterview) => (
                <>
                    {device === "desktop" ? (
                        <Link
                            onClick={() =>
                                handleOpenInterviewDetails(interview)
                            }
                        >
                            <Text>
                                {interview.startDateTime}{" "}
                                {
                                    domain.TimeZone.fromId(interview.timeZoneId)
                                        .abbreviation
                                }
                            </Text>
                        </Link>
                    ) : (
                        <Link
                            onClick={() =>
                                handleOpenInterviewDetails(interview)
                            }
                        >
                            <Text>
                                {interview.startDateTime.split(" ")[0]}
                                <br />
                                {interview.startDateTime
                                    .split(" ")
                                    .slice(1)
                                    .join(" ")}{" "}
                                {
                                    domain.TimeZone.fromId(interview.timeZoneId)
                                        .abbreviation
                                }
                            </Text>
                        </Link>
                    )}
                </>
            ),
        },
        {
            title: "type",
            field: "interviewTypeId",
            sortable: false,
            columnSize: "medium",
            render: (interview: domain.CandidateInterview) => (
                <Text>
                    {
                        domain.InterviewOptionsEnum.fromId(
                            interview.interviewTypeId
                        ).label
                    }
                </Text>
            ),
        },
        {
            title: "status",
            field: "interviewStatusTypeId",
            sortable: false,
            columnSize: "medium",
            render: (interview: domain.CandidateInterview) => (
                <>
                    <InterviewStatusDisplay
                        interviewStatusTypeId={interview.interviewStatusTypeId}
                    />
                </>
            ),
        },
        {
            title: "actions",
            field: "actions",
            hidden: isLastColumnHidden,
            align: "right",
            render: (interview: domain.CandidateInterview) => (
                <>
                    {handleOpenInterviewNotificationDialog &&
                    domain.InterviewStatusEnum.fromId(
                        interview.interviewStatusTypeId
                    ) === domain.InterviewStatusEnum.SCHEDULED ? (
                        <PageActionButton
                            onClick={() =>
                                handleOpenInterviewNotificationDialog(interview)
                            }
                            title="send reminder"
                            color="primary"
                            className={classes.actionButton}
                            dataCy={`${dataCy}-sendInterviewReminder-button`}
                        >
                            <EnvelopeIcon />
                        </PageActionButton>
                    ) : null}
                    {handleOpenEditInterview ? (
                        <PageActionButton
                            onClick={() => handleOpenEditInterview(interview)}
                            color="primary"
                            title="edit interview details"
                            className={classes.actionButton}
                            dataCy={`${dataCy}-openEditInterview-button`}
                        >
                            <EditIcon />
                        </PageActionButton>
                    ) : null}
                </>
            ),
        },
    ];
    return (
        <div id={`${extendedId}Wrapper`}>
            <EnhancedTable
                options={options}
                columns={columns}
                data={interviewList}
                dataCy={dataCy}
            />
        </div>
    );
};
